import { TrendingUp, TrendingDown, Minus } from "lucide-react";

export default function TrendIndicator({ trend, size = 14 }) {
    if (!trend) return <span className="text-[#8A9A86]">—</span>;
    if (trend === "rising") {
        return (
            <span className="inline-flex items-center gap-0.5 text-[#166534]" title="Rising spend trend">
                <TrendingUp size={size} />
            </span>
        );
    }
    if (trend === "declining") {
        return (
            <span className="inline-flex items-center gap-0.5 text-[#991B1B]" title="Declining spend trend">
                <TrendingDown size={size} />
            </span>
        );
    }
    return (
        <span className="inline-flex items-center gap-0.5 text-[#8A9A86]" title="Stable spend trend">
            <Minus size={size} />
        </span>
    );
}
